import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';

let blankItemStyle = getItemStyles('no-info');

const blockUnpostedDays = (startDate, groups, items, scheduleFormat) => {
  for (let group of groups){
    for (let i = 0; i < scheduleFormat; i++) {
      const date = moment(startDate).add(i, 'days');
      // check if group (resource) has any items on this day
      const haveItem = items.some(item => {
        return (
          item.group === group.id
          &&
          item.start_time.format('M/D') === date.format('M/D')
        );
      });
      if (!haveItem) {
        const blankItem = {
          id: `${group.id}-no-info-${date.format('M/D')}`,
          itemType: 'no-info',
          group: group.id,
          title: "No info",
          start_time: moment(date).startOf('day'),
          end_time: moment(date).endOf('day'),
          backgroundColor: blankItemStyle.backgroundColor,
          color: blankItemStyle.color,
          borderStyle: blankItemStyle.borderStyle,
          borderColor: blankItemStyle.borderColor
          };
          items.push(blankItem);
      }
    }
  }
  return items;
}

export default blockUnpostedDays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/live-schedule-view-security-filter/blockUnpostedDays.js